import React from "react";
import { ClockedInStatus, PatientTaskInstance, VisitInstanceDetails } from "../../../messages";
import { PatientTaskInstanceId } from "../../../messages/ObjectIds";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { REQUIRED_TASKS } from "../../../utils/svgs_new";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import { AppIcon } from "../../Generic/AppIcon";
import { AppList, AppListItem } from "../../Generic/AppList";
import NextButton from "../../NextButton/NextButton";
import TaskCard from "../../TaskCard";

interface Props {
  tasksPreview: PatientTaskInstance[];
  clockedInStatus: ClockedInStatus;
  onClickClockIn: (visitDetails: VisitInstanceDetails) => void;
  onClickClockOut: (visitDetails: VisitInstanceDetails) => void;
  onClickStartNow: (visitDetails: VisitInstanceDetails) => void;
  onClick: () => void;
  onClickTask: (
    taskInstanceId: PatientTaskInstanceId,
    initialScheduleDateTimePickerOpen: boolean
  ) => void;
}

const ListOfTasksCard = (props: Props) => {
  return (
    <AppCard className="ListOfTasksCard" onClick={props.onClick}>
      <AppCardContent>
        <AppList bordered={true}>
          <AppListItem
            leading={<AppIcon icon={REQUIRED_TASKS} />}
            title={translate(STRINGS.REQUIRED_TASKS)}
            trailing={<NextButton />}
          />
          {props.tasksPreview.map((taskInstance) => {
            return (
              <AppListItem
                key={taskInstance.id.toString()}
                title={
                  <TaskCard
                    onClick={props.onClickTask}
                    task={taskInstance}
                    clockedInStatus={props.clockedInStatus}
                    onClickClockIn={props.onClickClockIn}
                    onClickClockOut={props.onClickClockOut}
                    onClickStartNow={props.onClickStartNow}
                  />
                }
              />
            );
          })}
        </AppList>
      </AppCardContent>
    </AppCard>
  );
};

export default ListOfTasksCard;
